import { Component, ElementRef, Input, OnInit } from '@angular/core';

@Component({
  selector: 'app-button-more',
  templateUrl: './button-more.component.html',
  styleUrls: ['./button-more.component.scss']
})
export class ButtonMoreComponent implements OnInit {
  constructor(private el:ElementRef) { }

  ngOnInit(): void {
  }

  showMoreButton(){
    this.el.nativeElement.querySelector('#moreButton').click();
  }
}
